import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import FopList from 'apps/fops/containers/FopList';
import ShowMoreButton from 'apps/catalogue/components/ShowMoreButton';
import SubscriptionsFopElementsFactory from 'apps/fops/components/fopElementsFactories/SubscriptionsFopElementsFactory';
import AbstractFopContainer from 'apps/catalogue/components/AbstractFopContainer';
import { componentTypes } from 'apps/analytics';
import { SHOW_MORE_FOPS } from 'apps/catalogue/actions/catalogue';
import {
  FopContainerBasketItems, FopContainerViewPreferenceShape, FopContainerVisibleFops,
} from 'apps/catalogue/types';

const createVisibleProductsBySku = (visibleFops, productsBySku) => {
  // All FOPs returned in SSR shall be rendered (on server, there's no visibleFops)
  if (!visibleFops || !visibleFops.length) {
    return productsBySku;
  }

  // NOTE: please do not refactor to [].map() as it works much slower
  const result = {};
  for (let i = 0; i < visibleFops.length; ++i) {
    const { sku } = visibleFops[i];
    if (productsBySku[sku]) {
      result[sku] = productsBySku[sku];
    }
  }
  return result;
};

export default class SubscriptionsFopListContainer extends AbstractFopContainer {
  static propTypes = {
    afterBasketQuantityChange: PropTypes.func,
    basketItems: FopContainerBasketItems,
    betaFeatures: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    fopCollection: PropTypes.shape({
      sections: PropTypes.array.isRequired,
      totalFops: PropTypes.number.isRequired,
      maxDisplayFops: PropTypes.number.isRequired,
    }).isRequired,
    fopViewPreference: FopContainerViewPreferenceShape,
    gtmPageType: PropTypes.string,
    productsBySku: PropTypes.object.isRequired,
    productWarnings: PropTypes.objectOf(PropTypes.array),
    quickMenuExpanded: PropTypes.object,
    routeString: PropTypes.string.isRequired,
    scrollWatcher: PropTypes.object.isRequired,
    setMainFopCollectionMaxDisplayFops: PropTypes.func.isRequired,
    shoppingListsModal: PropTypes.bool,
    subscriptionsBySku: PropTypes.object,
    visibleFops: FopContainerVisibleFops,
  };

  static defaultProps = {
    betaFeatures: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.fopCollection !== prevProps.fopCollection) {
      this.props.scrollWatcher.check({ force: true });
    }
  }

  handleShowMoreClick = () => {
    const {
      fopCollection: { maxDisplayFops },
      routeString,
    } = this.props;

    const newMaxDisplayProps = maxDisplayFops + SHOW_MORE_FOPS;

    this.props.setMainFopCollectionMaxDisplayFops(routeString, newMaxDisplayProps);
  };

  render() {
    const {
      fopCollection: {
        sections,
        maxDisplayFops,
        totalFops,
      },
      betaFeatures,
      errorMessage,
      productsBySku,
      scrollWatcher,
      subscriptionsBySku,
      viewTypePreference,
      visibleFops,
    } = this.props;

    if (sections === undefined) {
      return null;
    }

    if (errorMessage) {
      return <p>{errorMessage}</p>;
    }

    // filter the products to only currently visible ones, so for others placeholders are used
    const visibleProductsBySku = createVisibleProductsBySku(visibleFops, productsBySku);

    const showMoreButton = (totalFops > maxDisplayFops)
      ? <ShowMoreButton onClick={this.handleShowMoreClick} />
      : null;

    const subscriptionsFopElementsFactory = new SubscriptionsFopElementsFactory({
      betaFeatures,
      productsBySku: visibleProductsBySku,
      subscriptionsBySku,
      viewTypePreference,
    });

    return (
      <Fragment>
        <FopList
          sections={sections}
          sectionRibbonDisplayed
          maxDisplayFops={maxDisplayFops}
          productsBySku={visibleProductsBySku}
          registerFopRef={scrollWatcher.registerFopRef}
          fopType={componentTypes.FOP_SUBSCRIPTIONS}
          fopElementsFactory={subscriptionsFopElementsFactory}
          gtmPageType="Subscriptions"
        />
        {showMoreButton}
      </Fragment>
    );
  }
}
